import Icon from '../components/Icon.vue'

Icon.register({"bus":{"width":512,"height":512,"paths":[{"d":"M512 152V232C512 245.3 501.3 256 488 256H480V424C480 437.3 469.3 448 456 448H448V488C448 501.3 437.3 512 424 512H376C362.7 512 352 501.3 352 488V448H160V488C160 501.3 149.3 512 136 512H88C74.7 512 64 501.3 64 488V448H56C42.7 448 32 437.3 32 424V256H24C10.7 256 0 245.3 0 232V152C0 138.7 10.7 128 24 128H32V80C32 35.8 132.3 0 256 0S480 35.8 480 80V128H488C501.3 128 512 138.7 512 152zM112 320C89.9 320 72 337.9 72 360S89.9 400 112 400 152 382.1 152 360 134.1 320 112 320zM400 320C377.9 320 360 337.9 360 360S377.9 400 400 400 440 382.1 440 360 422.1 320 400 320zM432 264V120C432 106.7 421.3 96 408 96H104C90.7 96 80 106.7 80 120V264C80 277.3 90.7 288 104 288H408C421.3 288 432 277.3 432 264z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bus.js
// module id = EEQS
// module chunks = 0